import { useMemo } from "react";
import { useSearchParams } from "react-router-dom";
import DailyExpenseReviewScreen from "../components/DailyExpense/DailyExpenseReviewScreen";
import { reviewLinkOf } from "../components/DailyExpense/dailyExpenseReview";

export default function DailyExpenseReviewPage() {
  const [searchParams] = useSearchParams();
  const search = searchParams.toString();
  const link = useMemo(() => reviewLinkOf(new URLSearchParams(search)), [search]);

  // A new link is a new preset: the screen starts over from it.
  return <DailyExpenseReviewScreen key={search} initialLink={link} />;
}
